import { useParams } from "react-router-dom";

export const LeadDetails = () => {
  const { leadId } = useParams<{ leadId: string }>();
  return <div>LeadDetails {leadId}</div>;
};
